import ViewControlRepo from './ViewControlRepo';

export default ViewControlRepo;
